export const getResumeFileType = (url) => {
  if (!url) {
    return null;
  }

  const lowerUrl = url.toLowerCase();
  if (lowerUrl.endsWith(".pdf")) {
    return "pdf";
  }
  if (lowerUrl.endsWith(".docx")) {
    return "docx";
  }
  if (lowerUrl.endsWith(".doc")) {
    return "doc";
  }

  return null;
};
